import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Header } from "./components/navbar/Header";
import { Footer } from "./components/navbar/Footer";
import Sports from "./components/sports/Sports";
import RegistrationFormDummy from "./components/Register/RegistrationFormDummy";
import About from "./components/abouthoa/history";
import { RajivGandhiAwardsPage } from "./components/awards/RajivGandhiAward";
import { DronacharyaAwardsPage } from "./components/awards/DronacharyaAward";
import { DhyanchandAwardsPage } from "./components/awards/DhyanchandAwards";
import { SocialMediaPage } from "./components/abouthoa/SocialMedia";
import { UpdatePage } from "./components/abouthoa/Update";
import { ArjunaAwardsPage } from "./components/awards/ArjunaAwards";
import { UpcomingEvents } from "./components/hoaUpComingEvents/Events";
import { Venues } from "./components/venus&facilities/Venues";
import LoginForm from "./components/Register/LoginForm";
import ForgotPassword from "./components/Register/ForgotPassword";
import DocumentsPage from "./components/ddocument/DocumentsPage";
import GalleryPage from "./components/media/gallery/GalleryPage";
import GalleryImage from "./components/media/gallery/GalleryFolder";
import GalleryFolderImage from "./components/media/gallery/GalleryImage";
import InfrastructurePage from "./components/media/gallery/Infrastructure";
import BlogsPage from "./components/media/blogssection/BlogsPage";
import BlogsDetailPage from "./components/media/blogssection/BlogsDetail";
import PressReleasesPage from "./components/media/pressrelease/PressReleasesPage";
import PressReleaseDetailPage from "./components/media/pressrelease/PressReleaseDetailPage";
import PdfPoliciesPage from "./components/ddocument/PdfPoliciesPage";
import PdfPoliciesPageWrapper from "./components/ddocument/PdfPoliciesPageWrapper";
import SportCategoryPage from "./components/sports/SportCategoryPage";
import SportDocumentsPage from "./components/sports/SportDocumentsPage";
import MemberPage from "./components/member/Member";
import OrganisationPage from "./components/organisation/Organisation";
import GalleryFolderPage from "./components/media/gallery/FolderImage";
import HomePage from "./pages/HomePage";

import MemberUnit from "./components/member/MemberASSOCIATEunit";
import Loader from "./components/Loader";
import SocialMedia from "./components/SocialMedia";
import ContactUs from "./components/abouthoa/ContactUs";
import NotFoundPage from "./components/404";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />

        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/athletes/login" element={<LoginForm />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/sports" element={<Sports />} />
            {/* ABOUT HOA */}
            <Route path="/pages/:slug" element={<About />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* document */}
            <Route path="/documents" element={<DocumentsPage />} />

            {/* Pdf Policeies */}
            {/* <Route path="/pdf-policies/:slug" element={<PdfPoliciesPage />} /> */}
            <Route
              path="/pdf-policies/:slug"
              element={<PdfPoliciesPageWrapper />}
            />

            {/* gallery */}
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/:folder" element={<GalleryImage />} />
            <Route
              path="/gallery/:folder/:slug"
              element={<GalleryFolderImage />}
            />
            <Route
              path="/infrastructure/:slug"
              element={<InfrastructurePage />}
            />

            {/* events */}
            <Route path="/events" element={<UpcomingEvents />} />

            {/* news */}
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/blogs/:slug" element={<BlogsDetailPage />} />

            {/* Press Release */}
            <Route path="/news" element={<PressReleasesPage />} />

            <Route path="/news/:slug" element={<PressReleaseDetailPage />} />
            {/* sport */}
            <Route path="/sports/:slug" element={<SportCategoryPage />} />
            <Route
              path="/sport-documents/:slug"
              element={<SportDocumentsPage />}
            />

            {/* member */}
            <Route path="/members/:slug" element={<MemberPage />} />
            <Route path="/member-units/:slug" element={<MemberUnit />} />

            {/* organisation */}
            <Route path="/organisation/:slug" element={<OrganisationPage />} />

            <Route
              path="/athletes/register"
              element={
                <div className="registration-page">
                  <RegistrationFormDummy />
                </div>
              }
            />
            {/* Awards */}
            <Route path="/award/:slug" element={<RajivGandhiAwardsPage />} />
            <Route path="/contents/:slug" element={<DhyanchandAwardsPage />} />
            <Route path="/Social-media" element={<SocialMediaPage />} />
            <Route path="/update-and-notifications" element={<UpdatePage />} />
            <Route
              path="/dronacharya-awards"
              element={<DronacharyaAwardsPage />}
            />
            <Route path="/document" element={<DocumentsPage />} />
            <Route
              path="/dhyanchand-awards"
              element={<DhyanchandAwardsPage />}
            />
            <Route path="/arjuna-awards" element={<ArjunaAwardsPage />} />
            {/* Venues Page */}
            <Route path="/venues" element={<Venues />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}
